module.exports = __webpack_public_path__ + "static/media/pi.5b18ab0a.png";